export const formatTime = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
};

export const getRandomImageNumber = () => {
  return String(Math.floor(Math.random() * 5) + 1).padStart(2, '0');
};

export const shuffleArray = (array) => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

export const getScoreMessage = (score, total, gameMode, difficulty, t) => {
  const percentage = Math.round((score / total) * 100);
  
  if (gameMode === 'code') {
    if (percentage >= 90) return t('scoreMessages.code.excellent');
    if (percentage >= 75) return t('scoreMessages.code.veryGood');
    if (percentage >= 60) return t('scoreMessages.code.good');
    if (percentage >= 40) return t('scoreMessages.code.average');
    return t('scoreMessages.code.poor');
  } else if (difficulty === 'easy') {
    if (percentage >= 95) return t('scoreMessages.plate.easy.excellent');
    if (percentage >= 85) return t('scoreMessages.plate.easy.veryGood');
    if (percentage >= 70) return t('scoreMessages.plate.easy.good');
    if (percentage >= 50) return t('scoreMessages.plate.easy.average');
    return t('scoreMessages.plate.easy.poor');
  } else {
    if (percentage >= 90) return t('scoreMessages.plate.hard.excellent');
    if (percentage >= 75) return t('scoreMessages.plate.hard.veryGood');
    if (percentage >= 60) return t('scoreMessages.plate.hard.good');
    if (percentage >= 40) return t('scoreMessages.plate.hard.average');
    return t('scoreMessages.plate.hard.poor');
  }
};